import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { usePlanTrialBanner } from "@/react/components/Layout/TrialBanner/usePlanTrialBanner";
import { planSettingsPath } from "@circle-react/helpers/urlHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const PlanTrialOffer = () => {
  const {
    isPlanTrialActive,
    planTrialDaysLeft,
    planTrialEndDateFormatted,
    planTrialExpiringInTimer,
    trackPlanTrialBannerClick,
  } = usePlanTrialBanner();
  const history = useHistory();

  if (!isPlanTrialActive) {
    return null;
  }

  const handleOnClick = () => {
    trackPlanTrialBannerClick();
    history.push(planSettingsPath());
  };

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-base">
          {t("plan_trial_banner.business_trial_ends_in_days", {
            days: planTrialDaysLeft,
          })}
        </Typography.BodySm>
        {planTrialExpiringInTimer && (
          <>
            <span className="text-darkest">
              {t("plan_trial_banner.separator")}
            </span>
            <Typography.BodySm weight="font-normal" size="text-base">
              {t("plan_trial_banner.renews", {
                formatted_date: planTrialEndDateFormatted,
                action: t("plan_trial_banner.cancel_anytime"),
              })}
            </Typography.BodySm>
          </>
        )}

        <Button
          className="ml-1 text-base font-semibold"
          variant="circle"
          onClick={handleOnClick}
        >
          {t("plan_trial_banner.manage_plan")}
        </Button>
      </div>
    </div>
  );
};
